<div class="notification-stock-update-container">

  @if (getIsComponentLoading) {
    <div class="content-container-main main-header" [class.duplicate-barcode-error]="isDuplicateBarcodeError">
      @if (!getNotification.success) {
        <app-shared-button
          [colour]="'danger'"
          [fill]="true"
          (buttonClicked)="onViewErrorClick()">
          View error
        </app-shared-button>
      }
      <span></span>
      <div class="content-container action-buttons">
        @if (getNotification.success) {
          <app-shared-button
            (click)="onViewChangesClick()"
            [fill]="false">
            View Changes
          </app-shared-button>
        }
        @if (!getNotification.success) {
          @if (isDuplicateBarcodeError) {
            <app-shared-button
              class="retry-action-button"
              [disabled]="getNotification.retried"
              (buttonClicked)="onRetryFullStockUpdateClick()"
              [fill]="false">
              Retry Full Update
            </app-shared-button>
            <app-shared-button
              class="retry-action-button"
              [disabled]="getNotification.retried"
              (buttonClicked)="onRetryWithoutFailedBarcodesClick()"
              [fill]="true">
              Retry Without Barcodes
            </app-shared-button>
          } @else {
            <app-shared-button
              [disabled]="getNotification.retried || isLoadingRetryData"
              (buttonClicked)="onRetryStockUpdateClick()"
              [fill]="false">
              @if (!isLoadingRetryData) {
                Retry
              } @else {
                <span class="loading-text">
                  Loading Data<span class="bouncing-dots"><span class="dot">.</span><span class="dot">.</span><span class="dot">.</span></span>
                </span>
              }
            </app-shared-button>
          }
        }
      </div>
    </div>
  } @else {
    <div class="notification-loader">
      <app-shared-loading-g
        [animation]="animation">
      </app-shared-loading-g>
    </div>
  }


</div>
